import { jsx as _jsx } from "react/jsx-runtime";
import { Typography, useMediaQuery, useTheme } from "@mui/material";
import { useCurrencyLocalizer } from "../../../Shared/hooks/useCurrencyLocalizer";
export const UpdatedCost = ({ showUpdatedCost, subtotal, }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    const { localizedCurrencyText: curr, isCredit } = useCurrencyLocalizer(subtotal, true);
    if (!showUpdatedCost)
        return null;
    const desktopCurrencyText = isCredit ? `Credit: ${curr}` : `+${curr}`;
    const mobileCurrencyText = isCredit ? `(${curr})` : `+${curr}`;
    const displayText = isMobile ? mobileCurrencyText : desktopCurrencyText;
    return _jsx(Typography, Object.assign({ variant: "body2" }, { children: displayText }));
};
